import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export type ILoginData = typeof initialState.loginData;
export type IRoleData = typeof initialState.role;

const initialState = {
  isAuth: false,
  isConnected: false,
  isFree: false,
  role: {
    _id: "",
    order: false,
    orderCreate: false,
    orderUpdate: false,
    orderDelete: false,
    orderState: false,
    orderStateCreate: false,
    orderStateUpdate: false,
    orderStateDelete: false,
    customer: false,
    customerCreate: false,
    customerUpdate: false,
    customerDelete: false,
    product: false,
    productCreate: false,
    productUpdate: false,
    productDelete: false,
    employee: false,
    employeeCreate: false,
    employeeUpdate: false,
    employeeDelete: false,
    role: false,
    roleCreate: false,
    roleUpdate: false,
    roleDelete: false,
    store: false,
    storeCreate: false,
    storeUpdate: false,
    storeDelete: false,
    storeProductCategory: false,
    storeProductCategoryCreate: false,
    storeProductCategoryUpdate: false,
    storeProductCategoryDelete: false,
    Category: false,
    CategoryCreate: false,
    CategoryUpdate: false,
    CategoryDelete: false,
    productCategory: false,
    productCategoryCreate: false,
    productCategoryUpdate: false,
    productCategoryDelete: false,
    admin: false,
    adminCreate: false,
    adminUpdate: false,
    adminDelete: false,
    integration: false,
    integrationUpdate: false,
    stateMap: false,
    transaction: false,
    banner: false,
    bannerCreate: false,
    bannerDelete: false,
    bannerUpdate: false,
    city: false,
    cityCreate: false,
    cityDelete: false,
    cityUpdate: false,
    measure: false,
    measureCreate: false,
    measureDelete: false,
    measureUpdate: false,
    settings: false,
    settingsUpdate: false,
    siteSettings: false,
    siteSettingsUpdate: false,
    transactionCreate: false,
    rateComment: false,
    rateCommentCreate: false,
    rateCommentUpdate: false,
    rateCommentDelete: false,
  },
  loginData: {
    _id: "",
    firstName: "",
    lastName: "",
    number: "",
    phoneNumber: "",
    createdAt: "",
    token: "",
  },
};

const LoginSlice = createSlice({
  name: "login-data",
  initialState,
  reducers: {
    setLoginData(state, payload: PayloadAction<ILoginData>) {
      state.loginData = payload.payload;
      state.isAuth = true;
      localStorage.setItem("admin", JSON.stringify(payload.payload));
    },
    setRoleData(state, payload) {
      state.role = payload.payload;
    },
    setSocketConnect(state, payload: PayloadAction<boolean>) {
      state.isConnected = payload.payload;
    },
    setIsFree(state, payload: PayloadAction<boolean>) {
      state.isFree = payload.payload;
    },
  },
});

export const { setLoginData, setRoleData, setSocketConnect, setIsFree } =
  LoginSlice.actions;

export default LoginSlice.reducer;
